import { render, staticRenderFns } from "./middle-bottom-copy.vue?vue&type=template&id=663ce591&scoped=true&"
import script from "./middle-bottom-copy.vue?vue&type=script&lang=js&"
export * from "./middle-bottom-copy.vue?vue&type=script&lang=js&"
import style0 from "./middle-bottom-copy.vue?vue&type=style&index=0&id=663ce591&scoped=true&lang=css&"
import style1 from "./middle-bottom-copy.vue?vue&type=style&index=1&id=663ce591&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663ce591",
  null
  
)

export default component.exports